<div class="container">
    <div class="wrapper">
        <h1 class="pageTitle" id="main-content" >
            {{pageTitle}}</h1>
        <h2 class="govuk-heading-m">{{verifyPageText}}</h2>
        @if(webhookResponseStatus) {
          <p class="govuk-body-l">{{ webhookResponseStatus | translate }}</p>
        }

        <!-- The pre-basket verify component sets these when the row reaches a
             FAILED/CANCELLED status, when the poll times out, or when the
             purchase is already paid. Without a panel a customer just sits on
             the "Verifying payment" spinner forever. -->
        @if(paymentFailed || maxRetriesReached || paymentAlreadyPaid) {
          <p class="govuk-body">
            If you have been charged, please contact the register office before
            trying again so we can check your payment.
          </p>
          <button type="button" class="govuk-button" (click)="restartJourney()">
            Start again
          </button>
        }

    </div>
</div>

@if(failed) {
  <div class="govuk-grid-column-two-thirds">
    <h1 class="govuk-heading-l">Sorry, there has been a problem</h1>
    <p class="govuk-body">Try again later.</p>
    <p class="govuk-body">Charge ID: {{ chargeId }}</p>
    <p class="govuk-body">Receipt: {{ receipt }}</p>
    <p class="govuk-body">Internal ref: {{ ref }}</p>
  </div>
}